import React, { useState, useEffect, useCallback } from 'react';
import { localToday } from '../../utils/dateUtils';
import './saude.css';
import Sidebar from '../../components/Sidebar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faPen } from '@fortawesome/free-solid-svg-icons';
import { useLocation } from 'react-router-dom';
import { useInternals } from '../../context/internalContext';
import { useAuxiliaries } from '../../context/auxiliariesContext';
import { useUsers } from '../../context/usersContext';
import { toast } from 'react-toastify';
import Header from '../../components/header';
import Titulo from '../../components/Titulo/titulo';
import InternalPhoto from '../../components/InternalPhoto';
import BinaryFileLink from '../../components/BinaryFileLink';
import { BINARY_RESOURCES, hasBinaryField } from '../../utils/binaryFile';
import SearchInternal from '../../components/SearchInternal/SearchInternal';
import ViewModal from '../../components/modal';
import InternalDataSkeleton from '../../components/InternalDataSkeleton';
import useSubmitLock from '../../utils/useSubmitLock';


const initializeExamData = () => ({
  date: localToday(),
  data: '',
  exam: null,   // File
  made_in_unit: false,
  result: '',
  type_exam: '',
});

const Admissao = () => {
  const location = useLocation();
  const { internalId } = location.state || {};
  const { userInfo, effectiveUnitId, buildUnitReadParams } = useUsers();

  const [internalDetails, setInternalDetails] = useState(null);

  const [currentTab, setCurrentTab] = useState('exames');

  const [examData, setExamData] = useState(initializeExamData());

  const [exams, setExams] = useState([]);

  const [typeExamList, setTypeExamList] = useState([]);

  const [editExam, setEditExam] = useState(null);
  const [isSelectingInternal, setIsSelectingInternal] = useState(false);
  const {
    isSubmitting: isSubmittingExam,
    runWithSubmitLock: runExamSubmit,
  } = useSubmitLock();
  const {
    isSubmitting: isUpdatingExam,
    runWithSubmitLock: runExamUpdateSubmit,
  } = useSubmitLock();

  const {
    listInternals,
    listExaminations,
    createExamination,
    updateExamination,
  } = useInternals();

  const {
    listTypeExam,
  } = useAuxiliaries();

  const loadAuxiliaryData = useCallback(async () => {
    try {
      const examTypesData = await listTypeExam();
      setTypeExamList(examTypesData?.results || []);
    } catch (error) {
      console.error('Erro ao carregar dados auxiliares:', error);
    }
  }, [listTypeExam]);


  const handleInternalSelect = useCallback(async (internal) => {
    if (!internal?.id) {
      toast.error("Erro ao selecionar interno.");
      return;
    }

    try {
      const examsRes = await listExaminations({ internal: internal.id, start_date: '2025-01-01' });
      setInternalDetails(internal);
      setExamData((prev) => ({ ...initializeExamData() }));
      setExams(examsRes?.results || []);
    } catch (error) {
      console.error('Erro ao carregar dados do interno:', error);
      toast.error('Erro ao carregar dados do interno.');
    }
  }, [listExaminations]);

  useEffect(() => {
    if (effectiveUnitId !== null && effectiveUnitId !== undefined && String(effectiveUnitId) !== '') {
      loadAuxiliaryData();
    }
  }, [loadAuxiliaryData, effectiveUnitId]);

  useEffect(() => {
    if (internalId) {
      const fetchInternalById = async () => {
        try {
          const response = await listInternals(buildUnitReadParams({ id: internalId }));
          const internalData = response?.results?.[0];
          if (internalData) handleInternalSelect(internalData);
        } catch (error) {
          console.error("Erro ao carregar interno pelo ID:", error);
          toast.error("Erro ao carregar interno.");
        }
      };
      fetchInternalById();
    }
  }, [internalId, handleInternalSelect, listInternals, buildUnitReadParams]);


  const handleExamSubmit = async (e) => {
    e.preventDefault();
    await runExamSubmit(async () => {
      if (!internalDetails?.id) return toast.error('Selecione um interno.');
      if (!examData.type_exam) return toast.error('Selecione o tipo de exame.');

      try {
        const data = new FormData();
        data.append('date', examData.date);
        data.append('data', examData.data || '');
        if (examData.exam) data.append('exam', examData.exam);
        data.append('internal', internalDetails.id);
        data.append('made_in_unit', examData.made_in_unit);
        data.append('result', examData.result || '');
        data.append('type_exam', examData.type_exam);
        data.append('health_professional', userInfo.id);

        await createExamination(data);
        const updatedExams = await listExaminations({ internal: internalDetails.id });
        setExams(updatedExams?.results || []);
        setExamData(initializeExamData());
      } catch (error) {
        console.error('Erro ao salvar exame:', error);
        toast.error('Erro ao salvar exame.');
      }
    });
  };

  const handleExamUpdate = async (e) => {
    e.preventDefault();
    await runExamUpdateSubmit(async () => {
      if (!internalDetails?.id) return toast.error('Selecione um interno.');
      if (!editExam.type_exam) return toast.error('Selecione o tipo de exame.');

      try {
        const data = new FormData();
        data.append('date', editExam.date);
        data.append('data', editExam.data || '');
        if (editExam.exam instanceof File) data.append('exam', editExam.exam);
        data.append('internal', internalDetails.id);
        data.append('made_in_unit', editExam.made_in_unit);
        data.append('result', editExam.result || '');
        data.append('type_exam', editExam.type_exam);
        data.append('health_professional', userInfo.id);

        await updateExamination(editExam.id, data);
        const updatedExams = await listExaminations({ internal: internalDetails.id });
        setExams(updatedExams?.results || []);
        setEditExam(null);
      } catch (error) {
        console.error('Erro ao atualizar exame:', error);
        toast.error('Erro ao atualizar exame.');
      }
    });
  };


  // Exames tab
  const renderExamesTab = () => (
    <div className="exames-container">
      <form onSubmit={handleExamSubmit} className="evolucao-container">
        <div className="social-form-group-duplo">
          <div className="social-form-group">
            <label>Data do Exame</label>
            <input
              type="date"
              name="date"
              value={examData.date}
              onChange={(e) => setExamData(prev => ({ ...prev, date: e.target.value }))}
            />
          </div>
          <div className="social-form-group">
            <label>Arquivo</label>
            <input
              type="file"
              accept="application/pdf"
              onChange={(e) =>
                setExamData(prev => ({
                  ...prev,
                  exam: e.target.files[0],
                }))
              }
            />
          </div>
        </div>

        <div className='social-form-group-duplo'>
          <div className="social-form-group">
            <label htmlFor="type_exam">Tipo de Exame</label>
            <select
              id="type_exam"
              className="social-form-group"
              name="type_exam"
              value={examData.type_exam}
              onChange={e => setExamData(prev => ({ ...prev, type_exam: e.target.value }))}
              required
            >
              <option value="">Selecione</option>
              {typeExamList.map(type => (
                <option key={type.id} value={type.id}>
                  {type.name}
                </option>
              ))}
            </select>
          </div>

          <div className="social-form-group">
            <label>Exame realizado na unidade</label>
            <select
              value={examData.made_in_unit.toString()}
              onChange={(e) =>
                setExamData((prev) => ({
                  ...prev,
                  made_in_unit: e.target.value === 'true',
                }))
              }
            >
              <option value="true">Sim</option>
              <option value="false">Não</option>
            </select>
          </div>
        </div>

        <div className="social-form-group">
          <label>Descrição</label>
          <textarea
            name="data"
            value={examData.data}
            onChange={(e) => setExamData(prev => ({ ...prev, data: e.target.value }))}
          />
        </div>
        <div className="social-form-group">
          <label>Resultado do Exame</label>
          <textarea
            className="form-control"
            value={examData.result}
            onChange={(e) => setExamData(prev => ({ ...prev, result: e.target.value }))}
            rows={3}
          />
        </div>
        <div className="social-form-group">
          <button type="submit" className="social-submit-button" disabled={isSubmittingExam}>
            {isSubmittingExam ? 'Salvando...' : 'Salvar Exame'}
          </button>
        </div>
      </form>

      <div className="timeline">
        <h4>Histórico de Exames</h4>
        <ul className="timeline-list">
          {exams.length > 0 ? exams.map((ex) => (
            <li key={ex.id || `${ex.type_exam}-${ex.date}`} className="timeline-item">
              <div className="timeline-date">
                <FontAwesomeIcon icon={faClock} /> {new Date(ex.date).toLocaleDateString()}
                <button
                  type="button"
                  className="edit-icon-button"
                  onClick={() => {
                    setEditExam(ex);
                  }}
                >
                  <FontAwesomeIcon icon={faPen} />
                </button>
              </div>
              <div className="timeline-content">
                <p><strong>Realizado na Unidade:</strong> {ex.made_in_unit ? "Sim" : "Não"}</p>
                <p><strong>Tipo de exame:</strong> {ex.type_exam_name}</p>
                <p>{hasBinaryField(ex, 'exam') && (
                  <BinaryFileLink resource={BINARY_RESOURCES.internalExamination} id={ex.id} field="exam">Ver Arquivo</BinaryFileLink>
                )}</p>
                <p><strong>Descrição:</strong> {ex.data}</p>
                <p><strong>Resultado:</strong> {ex.result}</p>

              </div>
            </li>
          )) : <p>Nenhum exame registrado.</p>}
        </ul>
      </div>

      <ViewModal
        isOpen={!!editExam}
        closeModal={() => setEditExam(null)}
        title="Editar Exame"
      >
        {editExam && (
          <form onSubmit={handleExamUpdate} className="evolucao-container">
            <div className="social-form-group-duplo">
              <div className="social-form-group">
                <label>Data do Exame</label>
                <input
                  type="date"
                  name="date"
                  value={editExam.date ? editExam.date.split('T')[0] : ''}
                  onChange={(e) => setEditExam(prev => ({ ...prev, date: e.target.value }))}
                />
              </div>
            </div>

            <div className='social-form-group-duplo'>
              <div className="social-form-group">
                <label htmlFor="type_exam_edit">Tipo de Exame</label>
                <select
                  id="type_exam_edit"
                  className="social-form-group"
                  name="type_exam"
                  value={editExam.type_exam || ''}
                  onChange={e => setEditExam(prev => ({ ...prev, type_exam: e.target.value }))}
                  required
                >
                  <option value="">Selecione</option>
                  {typeExamList.map(type => (
                    <option key={type.id} value={type.id}>
                      {type.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="social-form-group">
                <label>Realizado na unidade</label>
                <select
                  value={editExam.made_in_unit ? 'true' : 'false'}
                  onChange={(e) =>
                    setEditExam((prev) => ({
                      ...prev,
                      made_in_unit: e.target.value === 'true',
                    }))
                  }
                >
                  <option value="true">Sim</option>
                  <option value="false">Não</option>
                </select>
              </div>
            </div>

            <div className="social-form-group">
              <label>Descrição</label>
              <textarea
                name="data"
                value={editExam.data || ''}
                onChange={(e) => setEditExam(prev => ({ ...prev, data: e.target.value }))}
              />
            </div>
            <div className="social-form-group">
              <label>Resultado do Exame</label>
              <textarea
                className="form-control"
                value={editExam.result || ''}
                onChange={(e) => setEditExam(prev => ({ ...prev, result: e.target.value }))}
                rows={3}
              />
            </div>
            <div className="social-form-group">
              <button type="submit" className="social-submit-button" disabled={isUpdatingExam}>
                {isUpdatingExam ? 'Salvando...' : 'Atualizar Exame'}
              </button>
            </div>
          </form>
        )}
      </ViewModal>
    </div>
  );


  // Render principal
  const renderTabContent = () => {
    switch (currentTab) {
      case 'exames':
        return renderExamesTab();
      default:
        return null;
    }
  };

  return (
    <div>
      <Sidebar />
      <Header />
      <div className="container social-container">
        <Titulo
          children={
            <SearchInternal
              onSelect={handleInternalSelect}
              onSelectingChange={setIsSelectingInternal}
            />
          }
        />

        {/* <h4 className="h4-title">Outros</h4> */}
        {isSelectingInternal ? (
          <InternalDataSkeleton />
        ) : (
          <>
        <div className="content-topo">
          <div className="content-img">
            <InternalPhoto internal={internalDetails} alt="Foto interno" />
          </div>
          <div className="content-itens">
            <div>
              <p><strong>Nome:</strong> {internalDetails?.name || ''}</p>
              <p><strong>Nome social:</strong> {internalDetails?.social_name || ''}</p>
              <p><strong>Vulgo:</strong> {internalDetails?.aka || ''}</p>
              <p><strong>CPF:</strong> {internalDetails?.cpf || ''}</p>
            </div>
            <div>
              <p><strong>Unidade:</strong> {internalDetails?.unit_acronym || ''}</p>
              <p><strong>Pavilhão:</strong> {internalDetails?.pavilion_name || ''}</p>
              <p><strong>Cela:</strong> {internalDetails?.cell_name || ''}</p>
              <p><strong>Conduta:</strong> {internalDetails?.conduct?.name || ''}</p>
            </div>
          </div>
        </div>

        <div className="social-tabs">
          <button className={`social-tab-button ${currentTab === 'exames' ? 'active' : ''}`} onClick={() => setCurrentTab('exames')}>Exames</button>
        </div>

        <div className="social-tab-content">
          {renderTabContent()}
        </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Admissao;
